
import React from 'react';

export const LegacyDepsContext = React.createContext('');


export const withLegacyDeps = AReactComponent => (props => (
  <LegacyDepsContext.Consumer>
    {
      context => <AReactComponent legacyDeps={context} {...props} />
    }
  </LegacyDepsContext.Consumer>));
